<template>
  <div
    class="inline-spinner"
    :style="`
      width: ${width}px;
      height: ${height}px;
      border: ${border}px solid;
      border-color: ${primaryColor} ${primaryColor} ${secondaryColor};
    `"
  ></div>
</template>

<script>
export default {
  name: 'inline-spinner',
  props: {
    width: {
      type: Number,
      default: 20,
    },
    height: {
      type: Number,
      default: 20,
    },
    border: {
      type: Number,
      default: 3,
    },
    primaryColor: {
      type: String,
      default: '#36A3CA',
    },
    secondaryColor: {
      type: String,
      default: 'transparent',
    },
  },
};
</script>

<style lang="scss" scoped>
  @keyframes splash-loading-spinner {
    100% { transform: rotate(360deg) }
  }

  .inline-spinner {
    display: inline-block;

    animation: splash-loading-spinner 1s linear infinite;

    border-radius: 50%;
  }
</style>
